var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","align-start":"","justify-end":""}},[_c('v-flex',{staticClass:"hidden-sm-and-down text-md-left body-2 px-5",attrs:{"xs12":""}},[_vm._t("content"),_c('v-divider',{staticClass:"my-2",attrs:{"light":""}})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }